// import Cookies from "js-cookie";
// var CryptoJS = require("crypto-js");
import CryptoJS from "crypto-js";
import { createFileName } from 'use-react-screenshot/dist/index.es';
import * as htmlToImage from "html-to-image";
import moment from "moment";
import { toggleDotsOption } from "../store/actions/insurance/analytics.action";
import { copyImageToClipboard } from 'copy-image-clipboard';
import { toast } from 'react-toastify';

// Common Object Update
export const updateObject = (oldObject, updatedProperties) => {
  return {
    ...oldObject,
    ...updatedProperties,
  };
};

export const downloadCSV = (data, csvKeys, csvHeaders, filename = "ProviderTable-ByFormSubmission Date.csv") => {
  if (!data || data.length === 0) return;

  const totals = csvKeys.map((key, idx) => {
    if (idx === 0) return "Totals";
    const isNumeric = typeof data[0]?.[key] === "number";
    return isNumeric
      ? data.reduce((sum, row) => sum + (row[key] || 0), 0)
      : "";
  });

  const csvRows = [
    csvHeaders.join(","),
    totals.map(val => `"${val}"`).join(","),
    ...data.map(row =>
      csvKeys.map(key => `"${(row[key] ?? "").toString().replace(/"/g, '""')}"`).join(",")
    ),
  ];

  const csvContent = csvRows.join("\n");
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};



export const takeScreenshot = async (node) => {
  const dataURI = await htmlToImage.toPng(node);
  return dataURI;
};

export const DownloadImg = (image, { name = "analytics-" + moment().unix(), extension = 'png' } = {}) => {
  const file = document.createElement('a')
  file.href = image
  file.download = createFileName(extension, name);
  file.click()
}

export const getImage = (data) => takeScreenshot(data.current).then(DownloadImg)

export const copyImg = async (ref) => {

  const base64URL = await takeScreenshot(ref.current)

  copyImageToClipboard(base64URL)
    .then(() => {
      toast.success('Image Copied Successfully', {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    })
    .catch(() => {
      toast.error('The selected report has not been successfully copied yet. Please try again.', {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    })
}

// Encrypt 
export const encryption = (data) => {
  if (data) {
    let ciphertext = CryptoJS.AES.encrypt(
      JSON.stringify(data), process.env.REACT_APP_CRYPTO_KEY
    ).toString();
    return encodeURIComponent(ciphertext);
  }
};

// Decrypt localStorage
export const decryption = (data) => {
  let decryptedData = null;
  if (data) {
    let bytes = CryptoJS.AES.decrypt(decodeURIComponent(data), process.env.REACT_APP_CRYPTO_KEY);
    decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }
  return decryptedData;
};

// Encrypt localStorage
export const localStorageEncryption = (key, data) => {
  if (key && data) {
    let ciphertext = CryptoJS.AES.encrypt(
      JSON.stringify(data), process.env.REACT_APP_CRYPTO_KEY
    ).toString();
    sessionStorage.setItem(key, ciphertext);
  }
};

// Decrypt localStorage
export const localStorageDecryption = (key) => {
  const data = sessionStorage.getItem(key);
  let decryptedData = null;
  if (key && data) {
    let bytes = CryptoJS.AES.decrypt(data, process.env.REACT_APP_CRYPTO_KEY);
    decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }
  return decryptedData;
};




export const downloadCSVhart = (data, CsvName, headerOne, headerTwo) => {

  const monthWise = {};

  data.forEach(item => {
    const month = item.Date.slice(0, 7); // "YYYY-MM"
    const monthKey = `${month}-01`;

    // Initialize if not exists
    if (!monthWise[monthKey]) {
      monthWise[monthKey] = { month: monthKey };
    }

    // Go through each doctor key dynamically
    Object.keys(item).forEach(key => {
      if (key !== "Date" && key !== "date") {
        monthWise[monthKey][key] = (monthWise[monthKey][key] || 0) + item[key];
      }
    });
  });

  const result = Object.values(monthWise);

  if (!result || result.length === 0) {
    toast.warn("No data available for download");
    return;
  }

  console.log(result, "result");

  // Get all unique providers dynamically from the result data
  const providers = [];
  result.forEach(item => {
    Object.keys(item).forEach(key => {
      if (key !== 'month' && !providers.includes(key)) {
        providers.push(key);
      }
    });
  });

  // Sort providers alphabetically (or you can customize this sorting)
  providers.sort();

  // Helper function to escape CSV values
  const escapeCSVValue = (value) => {
    const stringValue = String(value);
    // If the value contains comma, quote, or newline, wrap in quotes and escape internal quotes
    if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
      return `"${stringValue.replace(/"/g, '""')}"`;
    }
    return stringValue;
  };

  // Create CSV structure
  const csvRows = [];

  // Single header row with proper structure
  const headerRow = [
    escapeCSVValue(headerOne),
    escapeCSVValue(headerTwo),
    ...providers.map(provider => escapeCSVValue(provider)),
    escapeCSVValue('Grand Total')
  ];
  csvRows.push(headerRow.join(','));

  // Data rows
  result.forEach(item => {
    const monthLabel = moment(item.month).format('MMM');
    const row = [
      escapeCSVValue(''), // Empty first column for data rows
      escapeCSVValue(monthLabel) // Month in second column
    ];

    let rowTotal = 0;
    providers.forEach(provider => {
      const value = item[provider] || 0;
      row.push(escapeCSVValue(value));
      rowTotal += value;
    });

    row.push(escapeCSVValue(rowTotal)); // Add row total
    csvRows.push(row.join(','));
  });

  // Calculate and add Grand Total row
  const grandTotalRow = [
    escapeCSVValue('Grand Total'),
    escapeCSVValue('') // Empty second column for Grand Total row
  ];
  let overallGrandTotal = 0;

  providers.forEach(provider => {
    const columnTotal = result.reduce((sum, item) => sum + (item[provider] || 0), 0);
    grandTotalRow.push(escapeCSVValue(columnTotal));
    overallGrandTotal += columnTotal;
  });

  grandTotalRow.push(escapeCSVValue(overallGrandTotal));
  csvRows.push(grandTotalRow.join(','));

  // Create and download the CSV file
  const csvContent = csvRows.join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');

  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `${CsvName}-${moment().format('YYYY-MM-DD')}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};